module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAM1BMVEUAAADu7u7u7u7u7u7u7u7u7u7u7u7u7u7t4uPnmqTianneOk/dLkTjdoTpsrnkgo7s1tkFgF/yAAAACHRSTlMAYL//ACDP71kzCuAAAADNSURBVHgB7ddNDgIhDIZh/qfQwnj/04o7jYNJh29BDM8B3hiVQs32vzbr/ARnQ2dCiMlPSvEVioefdsQeSh4gBWM9hDXOQzjjQXZonRDlwtJxyTQRoipvKt0NNZYP3O6FTvlyqkLjTi/pQ00uNW2IWC4xKUNVBqouRDJEqlCWoawKFRkqqhDLEKtC8gMs9FjuE+G/bPzPj/9D4o8I/tDixsh4sOFHLX74468j/AWJv7L3+2jtEO7BDlshYEsNbs2CLX4dZhUF2aEdWir0BGyxTm5iaypEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f1ef-1f1f5.png
// module id = 601
// module chunks = 0